import Link from 'next/link'
import { t } from 'i18next'
import { cn } from '~/core/ui/utils'

export type SubItemProps = {
  label: string
  subLabel?: string
  icon?: string
  href: string
  target?: string
  isSub?: boolean
  isSubNotLast?: boolean
}

const SubItem = ({
  subItem,
  target,
  smallText
}: {
  subItem: SubItemProps
  target?: string
  smallText?: boolean
}) => {
  return (
    <Link
      href={subItem.href}
      target={target || '_blank'}
      className={cn(
        'block px-4 py-2 rounded-lg',
        subItem.isSub ? '' : 'hover:bg-gray-100'
      )}>
      <div className="flex gap-3 items-center">
        {subItem.icon && (
          <img
            src={`/img/feature/lp/${subItem.icon}.png`}
            alt="user_permission"
            width={40}
            className=""
          />
        )}
        <div
          className={cn(
            'flex flex-col gap-[2px]',
            subItem.isSub
              ? 'relative bg-gray-50 w-full pl-[28px] py-3 pr-4'
              : '',
            subItem.isSubNotLast ? '-mb-4' : ''
          )}>
          {subItem.isSub ? (
            <div className="p-0 w-1 h-1 bg-gray-400 rounded-md absolute left-4 top-[22px]" />
          ) : null}
          <span className="text-base font-medium">{`${t('lp:' + subItem.label)}`}</span>
          {subItem.subLabel && (
            <span className="text-gray-700 text-sm">{`${t('lp:' + subItem.subLabel)}`}</span>
          )}
        </div>
      </div>
    </Link>
  )
}

export default SubItem
